const { CircularProgress } = require("@mui/material");
const { Box } = require("@mui/system");

export const Fallback = ()=> <Box sx={{ display: 'flex',    alignItems: 'center',
    justifyContent: 'center',height:'100%',position:'relative' }}>
      <CircularProgress color="inherit" />

    </Box>;